import React from 'react';
import {
  Text,
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  IDetailsListProps,
  DetailsRow,
  IColumn,
  useTheme,
} from '@fluentui/react';

interface IPlanillaDigitalExclusionesDetailList {
  exclusionesList: any[]; // todocambiar a interface
  color: string;
}

const PlanillaDigitalExclusionesDetailList = ({
  exclusionesList,
  color,
}: IPlanillaDigitalExclusionesDetailList) => {
  const oficialListColumns: IColumn[] = [
    {
      key: 'N°',
      fieldName: 'dorsal',
      name: 'N°',
      minWidth: 25,
      maxWidth: 25,
    },
    {
      key: 'Nombre',
      fieldName: 'nombre',
      name: 'Nombre',
      minWidth: 50,
      maxWidth: 150,
    },
    {
      key: 'Restante',
      fieldName: 'restante',
      name: 'Restante',
      minWidth: 40,
      // },
    },
  ];

  const getKey = (item: any, index?: number) => {
    return item.key;
  };
  const theme = useTheme();

  const _onRenderExclusionesRow: IDetailsListProps['onRenderRow'] = (props) => {
    if (props) {
      return (
        <div>
          <DetailsRow
            {...props}
            styles={{
              root: {
                backgroundColor: props.itemIndex % 2 === 0 ? theme.palette.neutralLight : 'transparent',
                selectors: {
                  ':hover': { backgroundColor: theme.palette.neutralQuaternaryAlt },
                },
              },
            }}
            className="planilla-detail-list"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <DetailsList
        items={exclusionesList}
        selectionMode={SelectionMode.none}
        columns={oficialListColumns}
        styles={{ headerWrapper: { borderBottom: `3px solid ${color} !important` } }}
        setKey="none"
        layoutMode={DetailsListLayoutMode.justified}
        isHeaderVisible={true}
        getKey={getKey}
        onRenderRow={_onRenderExclusionesRow}
        onShouldVirtualize={() => false}
      />
    </div>
  );
};

export default PlanillaDigitalExclusionesDetailList;
